import styled from "styled-components";

export const Content = styled.section`
  align-items: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  grid-area: content;
  overflow-y: auto;
`;
